module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c259e9086e890377322bc3bb01e2fefe.png";